// extracted by mini-css-extract-plugin
module.exports =  {"description":"style-module_description__cMsn86rnkXumjWhdzWtM"};